// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__H_P-J","content":"RecentSearches_content__m5Ihj"};